import Text from "common/Typography/Text";
import CopyToClipboardInput from "common/CopyToClipboard/CopyToClipboardInput";
import React from "react";
import { CSSProperties, useTheme } from "styled-components";
import {
  useWhitelistIPs as useSharedWhitelistIPs,
  useWhitelistIPsComponent,
} from "@shared/features/configuration/hooks";
import { GetWhitelistIpsRequest } from "@shared/types";

interface WhitelistIPsProps {
  style?: CSSProperties;
  onCopyClick?: () => void;
  showWarning?: boolean;
  args?: GetWhitelistIpsRequest;
}

const WhitelistIPs = ({
  style,
  onCopyClick,
  showWarning,
  args,
}: WhitelistIPsProps) => {
  const theme = useTheme();
  const { mainMessage, copyText, notificationPrefix } = useSharedWhitelistIPs({
    args,
  });

  return (
    <div style={style}>
      <Text $size={"S"} style={{ color: theme.colors.midDark }}>
        <span style={{ fontWeight: theme.typography.fontWeights.MEDIUM }}>
          Important:
        </span>{" "}
        {mainMessage}
      </Text>
      <CopyToClipboardInput
        text={copyText}
        notificationPrefix={notificationPrefix}
        style={{ marginTop: 12 }}
        onCopyClick={onCopyClick}
      />
      {showWarning && (
        <Text type="warning" style={{ marginTop: 4 }}>
          Please make sure to copy the IP addresses before proceeding{" "}
        </Text>
      )}
    </div>
  );
};

export const useWhitelistIPs = (
  exchange?: string,
  args?: GetWhitelistIpsRequest
) => {
  const {
    show,
    checkAllowSave,
    showCopyIPsWarning,
    setShowCopyIPsWarning,
    setCopyIPsClicked,
  } = useWhitelistIPsComponent(exchange);

  return {
    whitelistIPs: show && (
      <WhitelistIPs
        onCopyClick={() => {
          if (showCopyIPsWarning) setShowCopyIPsWarning(false);
          setCopyIPsClicked(true);
        }}
        showWarning={showCopyIPsWarning}
        style={{ marginTop: 12, marginBottom: 16 }}
        args={args}
      />
    ),
    checkAllowSave,
  };
};
